module.exports = __webpack_public_path__ + "img/7.a84d5aff.jpg";